export default __webpack_public_path__ + "static/media/project-management.37e6da5c.jpg";